
import { REVIEWS_LIST } from "../Reducers/reviewsListReducer";
import { fetchReviewsList } from "../Util/queries";
import { ReviewsList } from "../Model/companyReviewsObjects";

export const getReviewsList = (timeframe) => async (dispatch) => {
    try {
        const response = await fetchReviewsList(timeframe);
        dispatch({
            type: REVIEWS_LIST,
            payload: new ReviewsList(response.data, timeframe)
        });
    } catch (error) {
        console.error(error);
        dispatch({
            type: REVIEWS_LIST,
            payload: new ReviewsList({}, timeframe)
        });  
    }
}
